import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { getContext } from '~/components/core/Page/context'
import { useEmitter } from '~/composables/core'
import.meta.client && gsap.registerPlugin(ScrollTrigger)

// const PENDING_SCROLL_RESTORE_KEY = '__silkriverPendingScrollRestore'

// const consumePendingScrollRestore = () => {
// 	if (!import.meta.client) return null
// 	const savedPosition = window[PENDING_SCROLL_RESTORE_KEY]
// 	window[PENDING_SCROLL_RESTORE_KEY] = null
// 	return savedPosition
// }

// const restoreOrResetScroller = (emitter) => {
// 	const savedPosition = consumePendingScrollRestore()
// 	const top = Number(savedPosition?.top)

// 	if (Number.isFinite(top)) {
// 		emitter.emit('scroller-scrollTo', { href: top, immediate: true, duration: 0 })
// 		return
// 	}

// 	emitter.emit('scroller-reset')
// }

export function useTransition() {
	function onEnter(node, f) {
		return new Promise((resolve) => {
			const context = getContext(node.dataset.slug)
			const emitter = useEmitter()

			context.loader.dispatch('transition-ready')

			gsap.set(node, { clearProps: 'all' })
			gsap.fromTo(
				node,
				{
					autoAlpha: 0,
				},
				{
					autoAlpha: 1,
					duration: 0.5,
					delay: 0.25,
					ease: 'power4.out',
					onComplete: () => {
						gsap.set(node, { clearProps: 'all' })
						context.loader.dispatch('ready')
						// restoreOrResetScroller(emitter)
						emitter.emit('scroller-unlock')

						resolve()
					},
				}
			)
		})
	}

	function onLeave(node, f) {
		const emitter = useEmitter()

		return new Promise((resolve) => {
			gsap.fromTo(
				node,
				{
					autoAlpha: 1,
				},
				{
					autoAlpha: 0,
					duration: 0.5,
					ease: 'power4.out',
					onComplete: () => {
						emitter.emit('scroller-resize')
						ScrollTrigger.refresh()
						ScrollTrigger.update()

						f && f()
						resolve()
					},
				}
			)
		})
	}

	return {
		onEnter,
		onLeave,
	}
}
